import {post} from 'application/api/baseApi';
import axios from 'axios';

type Request = {
  to: string;
  subject: string;
  body: string;
};

type Response = {
  status: 'SUCCESS' | 'FAILURE';
  message: string;
};

const path = "https://default0196d5c89ee74581998acefe3171a4.d7.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/86d77e4523834e0c9ca094768f390c2a/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=0T59BUX9h7wDiyA8_nkKb-yaLv7Fm22orDSeOFWEjYs";


// Creating new instance, since the path above is to a new server
const newInstance = axios.create({
	headers: {
		'Content-Type': 'application/json'
	}
});

const sendEmailAPI = (req: Request) => post<Response>(path, {...req, attachment: ''}, newInstance);

export default sendEmailAPI;